module.exports = __webpack_public_path__ + "static/media/frp-app-image2.7a2928f8.png";